// extracted by mini-css-extract-plugin
module.exports = {"Logo":"FlohmarktLogo_Logo__LxdbR","LogoBaseline":"FlohmarktLogo_LogoBaseline__3u_De","LogoSize":"FlohmarktLogo_LogoSize__2mYpe"};